__turbopack_context__.v({
  "embla": "styles-module__Ya1fSW__embla",
});
